export default {
  "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
  "APP_FULFILLMENT_VIEW": "FULFILLMENT_APP_VIEW",
  "APP_LEGACY_FULFILLMENT_VIEW": "FULFILLMENT_LEGACY_APP_VIEW"
} as any 